import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import { PhoneFormatsType } from '@modules/global/types';

import { useCustomContext } from '../../context';
import SearchInput from '../SearchInput';

import style from './RecepientCountry.scss';

const cn = bemCssModules(style, 'RecepientCountry');
const ti = getTestId('RecepientCountry');

export type RecepientCountryType = {
  countries?: { value: PhoneFormatsType; label: string }[];
};

export const RecepientCountry: CustomFC<RecepientCountryType> = ({ className, countries }) => {
  const { t } = useTranslation();
  const {
    context: { country },
    setContext,
  } = useCustomContext();

  return (
    <SearchInput
      className={cn(null, [className])}
      data-testid={ti()}
      label={t('sepa.recipient_country')}
      placeholder={t('sepa.recipient_country_placeholder')}
      data={countries || []}
      dropdownClassName={cn('dropdown')}
      onChange={value => {
        setContext(draft => {
          draft.country = value.label;
        });
      }}
      outerValue={country}
      onlyDataValueAvailable
    />
  );
};

export default RecepientCountry;
